export default "__VITE_ASSET__ILFNtyVh__"